if (!customElements.get('footer-follow-on-shop')) {
  customElements.define(
    'footer-follow-on-shop',
    class FooterFollowOnShop extends HTMLElement {
      hydrated = false;
      onFocus = () => this.hydrate();

      connectedCallback() {
        if (this.hydrated || !this.querySelector('template')) return;
        this.footer = this.closest('footer');
        this.footer?.addEventListener('focusin', this.onFocus);

        if (typeof IntersectionObserver !== 'function' || this.footer?.contains(document.activeElement)) {
          this.hydrate();
          return;
        }

        this.observer = new IntersectionObserver(
          (entries, observer) => {
            if (observer === this.observer && entries.some((entry) => entry.isIntersecting)) this.hydrate();
          },
          { rootMargin: '0px 0px 400px 0px' }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.observer = undefined;
        this.footer?.removeEventListener('focusin', this.onFocus);
      }

      hydrate() {
        if (this.hydrated || !this.isConnected) return;
        const template = this.querySelector('template');
        if (!template) return;
        this.hydrated = true;
        this.disconnectedCallback();

        const content = template.content.cloneNode(true);
        // Fresh script elements execute the Shopify loader when its markup is inserted.
        content.querySelectorAll('script').forEach((source) => {
          const script = document.createElement('script');
          Array.from(source.attributes).forEach(({ name, value }) => script.setAttribute(name, value));
          script.textContent = source.textContent;
          source.replaceWith(script);
        });
        this.replaceChildren(content);
      }
    }
  );
}
